import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { PrimaryColors } from 'src/types/globalTypes';

export const CustomRadioButton = styled.div<{ primaryColors?: PrimaryColors }>`
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  margin-right: 30px;
  height: 34px;
  input {
    /* Hide the browser's default radio button */
    position: absolute;
    opacity: 0;
    cursor: pointer;
    :checked ~ span {
      background-color: ${colors.white};
    }
    :checked ~ span::after {
      display: block;
    }
	/* 新增：聚焦時的外框樣式 (參考之前討論的技巧) */
	&:focus + span {
	  outline: 2px solid #000000;
	  outline-offset: -2px;
	}
  }

  /* Create a custom radio button */
  span {
    position: absolute;
    top: 8px;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${colors.white};
    border: solid 1px
      ${(props) => (props.primaryColors ? props.primaryColors.third : colors.primaryBlue_100)};
    ::after {
      content: '';
      position: absolute;
      display: none;
      top: 3.5px;
      left: 3.7px;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: ${(props) =>
        props.primaryColors ? props.primaryColors.fifth : colors.primaryBlue_300};
    }
  }

  label {
    margin-left: 25px;
    line-height: 34px;
    color: ${colors.BlueGray_800};
    &:hover {
      cursor: pointer;
    }
  }
`;
